// 搜索适配参数
const ruleFormLayout = {
  data() {
    return {
      currentFormLayout: {
        labelCol: {
          xxl: { span: 2 },
          xl: { span: 3 },
          lg: { span: 3 },
          sm: { span: 5 },
          md: { span: 8 },
          xs: { span: 10 }
        },
        wrapperCol: {
          xxl: { span: 22 },//≥1600px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xl: { span: 21 },//≥1200px 响应式栅格，可为栅格数或一个包含其他属性的对象
          lg: { span: 19 },//≥992px 响应式栅格，可为栅格数或一个包含其他属性的对象
          sm: { span: 19 },//≥768px 响应式栅格，可为栅格数或一个包含其他属性的对象
          md: { span: 16 },//≥576px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xs: { span: 14 }//xs	<576px 响应式栅格，可为栅格数或一个包含其他属性的对象
        },
        offsetCol: {
          xxl: { offset: 2 },//≥1600px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xl: { offset: 3 },//≥1200px 响应式栅格，可为栅格数或一个包含其他属性的对象
          lg: { offset: 3 },//≥992px 响应式栅格，可为栅格数或一个包含其他属性的对象
          sm: { offset: 5 },//≥768px 响应式栅格，可为栅格数或一个包含其他属性的对象
          md: { offset: 8 },//≥576px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xs: { offset: 10 }//xs	<576px 响应式栅格，可为栅格数或一个包含其他属性的对象
        }
      },
      currentFormLayout2: {
        labelCol: {
          xxl: { span: 3 },
          xl: { span: 4 },
          lg: { span: 4 },
          sm: { span: 6 },
          md: { span: 9 },
          xs: { span: 11 }
        },
        wrapperCol: {
          xxl: { span: 21 },//≥1600px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xl: { span: 20 },//≥1200px 响应式栅格，可为栅格数或一个包含其他属性的对象
          lg: { span: 20 },//≥992px 响应式栅格，可为栅格数或一个包含其他属性的对象
          sm: { span: 18 },//≥768px 响应式栅格，可为栅格数或一个包含其他属性的对象
          md: { span: 15 },//≥576px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xs: { span: 13 }//xs	<576px 响应式栅格，可为栅格数或一个包含其他属性的对象
        },
        offsetCol: {
          xxl: { offset: 3 },//≥1600px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xl: { offset: 4 },//≥1200px 响应式栅格，可为栅格数或一个包含其他属性的对象
          lg: { offset: 4 },//≥992px 响应式栅格，可为栅格数或一个包含其他属性的对象
          sm: { offset: 6 },//≥768px 响应式栅格，可为栅格数或一个包含其他属性的对象
          md: { offset: 9 },//≥576px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xs: { offset: 11 }//xs	<576px 响应式栅格，可为栅格数或一个包含其他属性的对象
        }
      }
    }
  },
  methods: {}
}
export default ruleFormLayout
